import { Box, Text, Flex, Image } from "@chakra-ui/react";
import HomeIcon from "./assets/home.png";
import GoIcon from "./assets/go.png";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";

const NoBank = ({ onClick }: { onClick: () => void }) => {
  return (
    <Flex
      onClick={onClick}
      sx={{
        width: "100%",
        height: "170px",
        background: "#fff",
        borderRadius: "10px",
        overflow: "hidden",
        paddingTop: "16px",
        border: "1px solid #D8762B",
      }}
      flexDir={"column"}
      align={"center"}
    >
      <Text
        sx={{
          color: "#D8762B",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "14px",
          fontWeight: 900,
        }}
      >
        Bank Account
      </Text>
      <Image
        src={HomeIcon}
        sx={{
          width: "36px",
          marginTop: "20px",
        }}
      ></Image>{" "}
      <Text
        sx={{
          color: "#333",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 900,
          marginTop: "5px",
        }}
      >
        No Bank Account Connected
      </Text>
      <Flex
        sx={{
          marginTop: "auto",
          background: "#FFC773",
          height: "32px",
          padding: "0 30px",
          width: "100%",
        }}
        align={"center"}
        justify={"space-between"}
        width={"100%"}
      >
        <Text
          sx={{
            color: "#D8762B",
            fontSize: "14px",
            fontWeight: 700,
          }}
        >
          Connect Bank Account
        </Text>
        <Image
          src={GoIcon}
          sx={{
            width: "16px",
          }}
        ></Image>
      </Flex>
    </Flex>
  );
};

export default NoBank;
